<template>
  <v-form>
    <!-- 組織名 -->
    <TextInput
      v-model="formData.customer_name"
      :field-key="fieldKey('customer_name')"
      :label="$t('Customer.Name')"
      required
      class="mb-3"
    />
    <!-- 郵便番号 -->
    <TextInput
      v-model="formData.postal_code"
      :field-key="fieldKey('postal_code')"
      :label="$t('Address.PostalCode')"
      required
      :hint="$t('Address.Hint.PostalCode')"
      class="mb-3"
    />
    <!-- 住所1 -->
    <TextInput
      v-model="formData.address1"
      :field-key="fieldKey('address1')"
      :label="$t('Address.Address1')"
      required
      :hint="$t('Address.Hint.Address1')"
      class="mb-3"
    />
    <!-- 住所2 -->
    <TextInput
      v-model="formData.address2"
      :field-key="fieldKey('address2')"
      :label="$t('Address.Address2')"
      :hint="$t('Address.Hint.Address2')"
      class="mb-3"
    />
    <!-- 電話番号 -->
    <TextInput
      v-model="formData.tel"
      :field-key="fieldKey('tel')"
      :label="$t('Address.Tel')"
      required
      :hint="$t('Address.Hint.Tel')"
      class="mb-3"
    />
  </v-form>
</template>

<script>
  import TextInput from '@/components/parts/inputs/TextInput'
  import FormMixin from './FormMixin'

  export default {
    components: { TextInput },
    mixins: [FormMixin],
    props: {
      nestKey: {
        type: String,
        default: ''
      }
    },
    emits: ['form-data'],
    data: () => ({
      formData: {
        customer_name: '',
        postal_code: '',
        address1: '',
        address2: '',
        tel: ''
      }
    }),
    watch: {
      // formData変更を親コンポーネントへ渡す
      formData: {
        handler: function () {
          this.$emit('form-data', this.formData)
        },
        deep: true
      }
    },
    created() {
      this.applyCurrentData()
    }
  }
</script>

<style scoped>

</style>
